import logger from 'src/utils/logger/logger';
export default function detection (agent) {
  let comp_agent = agent.indexOf("sony") != -1;
  if (comp_agent) {
    logger.info ("[sony detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/sony/detection.js